import "core-js/modules/es.array.push.js";
import Vue from "vue";
import { Message } from "view-design";
import Router from "@/router";
import $store from "@/store";
import store from "store2";
import { getBrowerLang } from "@/utils/util";
import { multipleJs } from "@/libs/multiple-instances-http.js";
const http = axios => {
  Vue.prototype.$http = axios;
  Message.config({
    duration: 3
  });
  axios.defaults.timeout = 7000;
  // 请求基础路径从 server.json 接口读取，服务器替换 dist/server.json 即可切换环境。
  axios.defaults.baseURL = "/";
  axios.interceptors.request.use(config => {
    //这边可根据自己的需求设置headers，我司采用basic基本认证
    config.headers["language"] = store.get("language") || getBrowerLang() || "zh-CN";
    // config.headers["Accept-Language"] =
    //   store.get("language") || getBrowerLang() || "zh-CN";
    config.headers["Content-Type"] = "application/json;charset=utf-8";
    // 如果有current，就替换成firstResult
    const params = config.params;
    if (params) {
      if (Object.prototype.hasOwnProperty.call(params, "current")) {
        // console.log(params);
        config.params.firstResult = params.current;
        delete config.params.current;
      }
    }
    return config;
  }, err => {
    // nomsg 请求由业务自行处理失败，不显示请求阶段的全局提示。
    if (err.config && err.config.headers && err.config.headers.nomsg) {
      return Promise.resolve(err);
    }
    Message.error({
      content: $t("6qsnvf5", "请求超时!")
    });
    return Promise.resolve(err);
  });
  axios.interceptors.response.use(data => {
    const {
      nomsg
    } = data.config.headers;
    if (data.data.result === 0) {
      data.success = true;
    }
    if (data.status && (data.status != 200 || data.data.result != 0)) {
      if (data.data.result === 14901) {
        return multipleJs.multipleInstances(data, axios);
      }
      if (!(data.data instanceof Blob) && typeof data.data !== "string" &&
      // 排除字符串响应（如CSV）
      data.data.result !== 401 && data.data.result !== 25003) {
        if (!nomsg) {
          Message.error({
            content: data.data.msg || $t("diprg14", "未知错误")
          });
        }
      }
      // 后端设置了时间，客户端如果没有在此时间内操作则需要重新登录，如果401，说明需要重新登录
      if (data.status && data.data.result === 401) {
        $store.dispatch("handleLogOutNoAccord");
        if (Router.app._route.name === "Login") {
          window.location.reload();
        } else {
          Router.push({
            name: "Login"
          });
        }
      }
      if (data.status && data.data.result === 16001) {
        Router.push({
          name: "Login"
        });
      }
    }
    return data;
  }, err => {
    // 与业务错误保持一致，nomsg 同时屏蔽 HTTP、超时和网络异常提示。
    if (err.config && err.config.headers && err.config.headers.nomsg) {
      return Promise.resolve(err);
    }
    if (err.response) {
      if (err.response.status == 504 || err.response.status == 404) {
        Message.error({
          content: $t("qbkckca", "服务器被吃了⊙﹏⊙∥")
        });
      } else if (err.response.status == 403) {
        Message.error({
          content: $t("b5srw3c", "权限不足,请联系管理员!")
        });
      } else Message.error({
        content: `${err.response.status}：${err.response.statusText || err.response.error}`
      });
    } else if (err.code === "ECONNABORTED" && err.message.indexOf("timeout") !== -1) {
      Message.error({
        content: $t("6qsnvf5", "请求超时!")
      });
    } else {
      Message.error({
        content: err.message || $t("diprg14", "未知错误")
      });
    }
    return Promise.resolve(err);
  });
};
export default http;